var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-cover"},[(!_vm.homeSection.exists)?_c('b-skeleton-img',{attrs:{"no-aspect":"","height":"250px"}}):_c('b-img',{staticClass:"cover-img",attrs:{"src":_vm.cover}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }